module.exports = __webpack_public_path__ + "static/media/logo.db48dd11.svg";